import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconHeartsIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 160;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <circle cx="80.5" cy="80" r="80" fill="#FCEED7" />
      <g clipPath="url(#clip0_2998_27683)">
        <path
          d="M68.241 61.5749C59.412 63.9512 57.7096 72.0347 57.5232 72.4196C56.8152 73.8649 55.5204 74.4696 53.7561 73.4011C46.7761 66.325 34.9418 67.7939 29.9475 76.4577C27.9325 79.9522 27.3994 84.0179 28.4444 87.9047C32.8291 104.2 50.6514 113.219 66.558 116.1C66.7957 116.143 67.0366 116.132 67.2644 116.071C67.4939 116.009 67.7096 115.898 67.8943 115.74C69.8539 114.073 74.902 109.496 79.4397 103.005C86.8942 92.3431 89.3421 81.9883 86.716 72.2267C84.5561 64.2026 76.2692 59.424 68.241 61.5749Z"
          fill="#FFA69E"
        />
        <path
          d="M39.7986 84.8673C38.7528 80.9814 39.2867 76.9156 41.3008 73.4211C42.3132 71.6641 43.6104 70.209 45.0875 69.0559C39.2899 68.2616 33.1832 70.8495 29.9475 76.4631C27.9325 79.9584 27.3994 84.0234 28.4444 87.9101C32.8291 104.206 50.6514 113.224 66.558 116.105C67.0439 116.193 67.5322 116.054 67.8943 115.745C68.7846 114.989 70.3146 113.628 72.1424 111.762C57.9301 107.917 43.6576 99.213 39.7986 84.8673Z"
          fill="#FF766A"
        />
        <path
          d="M67.9782 75.5306C61.4083 77.2982 60.142 83.3138 60.0029 83.6003C59.4764 84.6753 58.5128 85.1254 57.2001 84.3303C52.0065 79.065 43.2003 80.1579 39.4845 86.6049C37.9854 89.205 37.5883 92.2299 38.3663 95.1221C41.6288 107.248 54.8898 113.958 66.7257 116.102C66.9031 116.135 67.0822 116.126 67.2523 116.081C67.4223 116.035 67.5827 115.951 67.7202 115.834C69.1785 114.594 72.935 111.187 76.3115 106.358C81.8584 98.4254 83.6797 90.7203 81.7257 83.4571C80.1185 77.4854 73.9523 73.9299 67.9782 75.5306Z"
          fill="#FFB8B1"
        />
        <path
          d="M67.7202 115.83C68.5543 115.121 70.1404 113.7 71.9772 111.714C58.1059 107.926 44.2224 99.5035 40.0484 85.7258C39.8507 86.0065 39.6602 86.2954 39.4845 86.6006C37.9854 89.2007 37.5883 92.2256 38.3663 95.1179C41.6288 107.244 54.8898 113.954 66.7257 116.098C67.07 116.16 67.4402 116.068 67.7202 115.83Z"
          fill="#E54A4A"
        />
        <path
          d="M64.1203 56.6927L59.034 50.555C58.4668 49.8706 58.562 48.8558 59.2465 48.2886C59.9309 47.7205 60.9457 47.8157 61.5129 48.501L66.5992 54.6379C67.1664 55.3231 67.0712 56.3371 66.3868 56.9043C65.7032 57.4715 64.6875 57.3771 64.1203 56.6927Z"
          fill="#FDBD5D"
        />
        <path
          d="M96.1544 56.9048C95.47 56.3375 95.3748 55.3227 95.942 54.6383L101.028 48.5006C101.596 47.8154 102.61 47.721 103.295 48.2882C103.979 48.8554 104.074 49.8703 103.507 50.5547L98.4209 56.6924C97.8536 57.3768 96.8388 57.4712 96.1544 56.9048Z"
          fill="#FDBD5D"
        />
        <path
          d="M81.2784 53.1216C80.3889 53.1216 79.6687 52.4014 79.6687 51.5119V44.1763C79.6687 43.2868 80.3889 42.5666 81.2784 42.5666C82.1671 42.5666 82.8881 43.2868 82.8881 44.1763V51.5119C82.8881 52.4014 82.1671 53.1216 81.2784 53.1216Z"
          fill="#FDBD5D"
        />
        <path
          d="M123.412 69.3635C114.577 67.0068 109.061 73.1559 108.707 73.3959C107.372 74.2936 105.948 74.1699 104.954 72.3616C103.969 68.5839 101.676 65.5737 98.7301 63.614C97.0927 63.9347 95.4684 64.5238 93.9173 65.4215C90.3121 67.5056 87.7364 70.865 86.6647 74.8795C82.7918 89.3937 90.6458 104.225 101.046 114.951C104.169 114.112 108.193 112.805 112.396 110.842C124.182 105.336 131.479 97.5919 134.086 87.8255C136.228 79.7965 131.44 71.5144 123.412 69.3635Z"
          fill="#FFA69E"
        />
        <path
          d="M87.1316 75.3044C88.17 71.4152 90.6643 68.1617 94.1572 66.1426C95.9117 65.1278 97.7623 64.5158 99.6186 64.2554C94.9946 60.669 88.4117 59.8568 82.803 63.1006C79.311 65.1197 76.8158 68.3732 75.7782 72.2624C71.4277 88.567 82.353 105.288 94.6878 115.737C95.0646 116.056 95.5569 116.179 96.0249 116.094C97.1748 115.883 99.1792 115.469 101.696 114.767C91.3097 104.332 83.3019 89.6575 87.1316 75.3044Z"
          fill="#FF766A"
        />
        <path
          d="M116.213 81.3199C109.639 79.5661 105.535 84.1421 105.272 84.3204C104.278 84.9885 103.218 84.8965 102.479 83.5513C100.613 76.3947 92.4411 72.9385 85.9998 76.6633C83.4005 78.1656 81.5451 80.5875 80.7728 83.4805C77.5346 95.6127 85.6645 108.055 94.8426 115.83C94.9801 115.946 95.1397 116.029 95.3089 116.074C95.479 116.12 95.6597 116.128 95.8379 116.095C97.721 115.75 102.677 114.678 108.016 112.184C116.786 108.087 122.217 102.325 124.155 95.0577C125.749 89.0836 122.186 82.9206 116.213 81.3199Z"
          fill="#FFB8B1"
        />
        <path
          d="M95.8371 116.093C96.9146 115.895 98.9979 115.459 101.582 114.656C91.4637 104.44 83.6512 90.2041 86.9251 76.1855C86.6134 76.3296 86.3042 76.485 85.9998 76.6608C83.4005 78.1639 81.5451 80.585 80.7728 83.478C77.5346 95.6102 85.6645 108.052 94.8426 115.828C95.1095 116.053 95.4758 116.159 95.8371 116.093Z"
          fill="#E54A4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2998_27683">
          <rect
            width="106.667"
            height="106.667"
            fill="white"
            transform="translate(27.9219 25.9062)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconHeartsIllustration;
